var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon screen"},[_c('div',{staticClass:"icon-user-clock"},[_c('VImg',{staticClass:"user-clock",attrs:{"src":require('@/assets/icons/header/icon-user-clock.svg')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }